module.exports = __webpack_public_path__ + "static/img/sanhe_main_tit.c09d477.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductDetails/assets/sanhe_main_tit.png
// module id = YXAa
// module chunks = 19